/**
 * @file   carwash_website\Carwash-FrontEnd\src\Pages\SmallCarWashSignGeneration.tsx
 * @brief  Add/Edit user page.
 * @date   SEP, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Container, Button, Form, useOutletContext, useEffect, useState, useParams, Modal } from '../utils/thirdpartyComponents';
import PlusIcon from "../assets/images/plus-icon-grey.svg";
import CarTheme1 from '../assets/images/theme-1.png';
import CarTheme2 from '../assets/images/theme-2.png';
import CarTheme3 from '../assets/images/theme-3.png';
import SmallSignTemplate01 from '../components/SmallSignTemplate01';
import SmallSignTemplate02 from '../components/SmallSignTemplate02';

import FreeVacuumTemplate03 from '../components/FreeVacuumTemplate03';
import { TITLE_CONTENT_LIMIT,SUBSCRIPTION_CONTENT_LIMIT,THEME1_PRIMARY_COLOR, THEME1_SECONDARY_COLOR, THEME1_TEXT_COLOR, THEME2_PRIMARY_COLOR, THEME2_SECONDARY_COLOR, THEME2_TEXT_COLOR } from '../utils/constants';

import { AppContextType } from '../interfaces/generalInterface';
import { MessageToaster } from "../utils/toastUtil";
import SmallLoader from '../components/SmallLoader';
import CWSelect from '../components/CWSelect';
import CWInput from '../components/CWInput';
import CWTextarea from '../components/CWTextarea';
import { FontSizeType, BoxFontSizeType, EquipmentType, EquipmentTypeLabel } from '../utils/enums';
import { userType } from '../utils/enums';
import axios from '../config/axiosConfig';
import { SigngenApi } from "../utils/apiUrls";
import ThemeLogo from '../assets/images/theme1-logo.svg';



const MEMBERSHIP_DEFAULTS = {
    titlecontent: 'Monthly Membership 5 Washes Per Month',
    subscriptionbox1: 'Starting $28 Monthly',
    subscriptionbox2: '$10 First 30 Days',
    subscriptionbox3: 'Cancel Anytime',
};

const FREE_VACUUM_DEFAULTS = {
    titlecontent: 'TO GET YOUR FREE VACUUM WITH EVERY WASH',
    subscriptionbox1: 'CREATE YOUR ACCOUNT',
    subscriptionbox2: 'SELECT WASH OR MEMBERSHIP',
    subscriptionbox3: 'USE APP TO CONTROL THE START AND STOP TIME ON THE TIMER',
};

const FREE_VACUUM_PRIMARY_COLOR = '#FFFFFF';
const FREE_VACUUM_SECONDARY_COLOR = '#00808A';
const FREE_VACUUM_TEXT_COLOR = '#003D8D';
const FREE_VACUUM_TITLE_LIMIT = 60;
const FREE_VACUUM_STEP_LIMIT = 80;

const SmallCarWashSignGeneration = (props: { edit?: boolean | undefined; userType?: string; }) => {

    const carwash_owner = (props.userType === userType['CARWASH-OWNER']) ? true : false;
    const param = useParams();
    const equipment_id = param.equipment_id ? param.equipment_id : 0;

    const [selectedTheme, setSelectedTheme] = useState<number>(1);
    const handleThemeChange = (theme: number) => {
        setSelectedTheme(theme);
    };

    // Convert FontSizeType enum to an array of options
    const fontSizeOptions = [
        ...Object.values(FontSizeType).map(fontSize => ({
            label: fontSize,
            value: fontSize
        }))
    ];

    // Convert Box FontSizeType enum to an array of options
    const boxfontSizeOptions = [
        ...Object.values(BoxFontSizeType).map(fontSize => ({
            label: fontSize,
            value: fontSize
        }))
    ];

    const [themeData1, setThemeData1] = useState({
        Theme1PrimaryColor: THEME1_PRIMARY_COLOR,
        Theme1SecondaryColor: THEME1_SECONDARY_COLOR,
        Theme1TextColor: THEME1_TEXT_COLOR
    });
   
    const [themeData2, setThemeData2] = useState({
        Theme2PrimaryColor: THEME2_PRIMARY_COLOR,
        Theme2SecondaryColor: THEME2_SECONDARY_COLOR,
        Theme2TextColor: THEME2_TEXT_COLOR
    });

    const [themeData3, setThemeData3] = useState({

        Theme3PrimaryColor: FREE_VACUUM_PRIMARY_COLOR,
        Theme3SecondaryColor: FREE_VACUUM_SECONDARY_COLOR,
        Theme3TextColor: FREE_VACUUM_TEXT_COLOR

    });

    const [bayId] = useState(equipment_id);
    const [bayName, setbayName] = useState("");
    const [BayTypeID,setBayTypeID] = useState(1);
    const [companyLogoUrl, setcompanyLogoUrl] = useState(ThemeLogo);
    const [appUrl, setappUrl] = useState("");

    const [formData, setFormData] = useState({
        // Color fields
        PrimaryColor: selectedTheme === 1 ? themeData1.Theme1PrimaryColor : selectedTheme === 2 ? themeData2.Theme2PrimaryColor : themeData3.Theme3PrimaryColor ,
        SecondaryColor: selectedTheme === 1 ? themeData1.Theme1SecondaryColor : selectedTheme === 2 ? themeData2.Theme2SecondaryColor : themeData3.Theme3SecondaryColor ,
        ButtonPrimaryColor: selectedTheme === 1 ? themeData1.Theme1TextColor : selectedTheme === 2 ? themeData2.Theme2TextColor : themeData3.Theme3TextColor ,
        
        // Text inputs
        washname: 'Wave Car Wash',
        titlecontent: 'Monthly Membership 5 Washes Per Month',
        subscriptionbox1: 'Starting $28 Monthly',
        subscriptionbox2: '$10 First 30 Days',
        subscriptionbox3: 'Cancel Anytime',
      
        // Font size selections
        washnamefontsize: '32px', 
        box1fontsize: '20px',
        box2fontsize: '20px',
        box3fontsize: '20px',
      });


      const bayTypeLabelMap: { [key: number]: EquipmentTypeLabel } = {
        1: EquipmentTypeLabel.Tunnel,
        2: EquipmentTypeLabel.Bay,
        3: EquipmentTypeLabel.SelfServe,
        4: EquipmentTypeLabel.DogWash,
        5: EquipmentTypeLabel.Vacuum,
      };
      function getBayLabel(item: any): string {
        if (item.BayName) return item.BayName;
        if (item.BayTypeID && item.BayNumber) {
          return `${bayTypeLabelMap[item.BayTypeID] || "Unknown"} ${item.BayNumber}`;
        }
        return "Unknown";
      }

      const getDetails = async () => {
        try {
          setLoading(true);
          // const { data } = await axios.get(`${OrderHardwareApi.ORDER_HARDWARE_LIST}?pageNo=${pageNo}`);
          const { data } = carwash_owner ? await axios.get(SigngenApi.CARWASH_OWNER_GET_DETAILS_FOR_SIGN+equipment_id) :
                                           await axios.get(SigngenApi.GET_DETAILS_FOR_SIGN+equipment_id) ;
    
          if (data?.error === 0) {
            setcompanyLogoUrl(data?.data.LogoFile ? `${process.env.REACT_APP_S3_URL_PUBLIC_PATH}${data?.data.LogoFile}` : ThemeLogo);
            if(data?.data.CarWashURL)
            {
                setappUrl(process.env.REACT_APP_CARWASH_APP_BASE_URL + data?.data.CarWashURL);
            }
            
           
            setBayTypeID(data?.data?.BayTypeID ? data?.data?.BayTypeID : 1);
            const bay_namme = getBayLabel(data?.data)
            setbayName(bay_namme);

            setFormData({
                ...formData,
                washname: data.data.CompanyName,
            });
          }
          else {
            toaster.toastError(data?.message);
          }
        } catch (error: any) {
          throw new Error(error.response?.data?.message || error.message);
        } finally {
          setLoading(false);
        }
      }

      useEffect(() => {
        getDetails()
      }, []);

      // Example handler to update formData
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement> |  React.ChangeEvent<HTMLTextAreaElement>) => {
        const { name, value } = event.target;
        if(name === "titlecontent")
        {
            // Split into lines and limit to 2 lines
            const lines = value.split("\n").slice(0, 3).join("\n");

            setFormData({
                ...formData,
                [name]: lines,
            });
        }
        else
        {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
        
    };

    // Triggers on input change
    const handleSelectChange = (selectedOption: any, name: string) => {

        const value = selectedOption?.value || '';
        setFormData({
            ...formData,
            [name]: value,
        });

    }    

    const [showResetpoup, setShowResetpoup] = useState<boolean>(false);
    //Hide ppopup
    const hideResetModal = () => {
        setShowResetpoup(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    const showResetModal = () => {
        setShowResetpoup(true);
    }

    const [loading, setLoading] = useState(false);
    const toaster = new MessageToaster();

    // Access the context
    const { updateData } = useOutletContext<AppContextType>();
    useEffect(() => {
        handleUpdate()
    }, [])

    // Update the data
    const handleUpdate = () => {
        updateData({ heading: "Generate Sign", url: "", showBackButton: false, showMainMenu: true, activeLink: "cwo-app-settings" });
    };

    const ColorChangeHandler = (e: any) => {
        e.target.parentElement.style.background = e.target.value;
        e.target.parentElement.children[0].style.display = "none";
        document.documentElement.style.setProperty('--' + e.target.name, e.target.value);
        if(selectedTheme === 1)
        {
            setThemeData1({
                ...themeData1,
                [e.target.name]: e.target.value,
            });
        }
        else if(selectedTheme === 2)
        {
            setThemeData2({
                ...themeData2,
                [e.target.name]: e.target.value,
            });
        }
        else if(selectedTheme === 3)
        {
            setThemeData3({
                ...themeData3,
                [e.target.name]: e.target.value,
            });
        }
        
    }


    const resetCustomTheme = async () => {
        setShowResetpoup(false);
        setFormData({
            // Color fields
            PrimaryColor: selectedTheme === 1 ? themeData1.Theme1PrimaryColor : selectedTheme === 2 ? themeData2.Theme2PrimaryColor : themeData3.Theme3PrimaryColor ,
            SecondaryColor: selectedTheme === 1 ? themeData1.Theme1SecondaryColor : selectedTheme === 2 ? themeData2.Theme2SecondaryColor : themeData3.Theme3SecondaryColor ,
            ButtonPrimaryColor: selectedTheme === 1 ? themeData1.Theme1TextColor : selectedTheme === 2 ? themeData2.Theme2TextColor : themeData3.Theme3TextColor ,
            
            // Text inputs
            washname: formData.washname,
            titlecontent: 'Monthly Membership 5 Washes Per Month',
            subscriptionbox1: 'Starting $28 Monthly',
            subscriptionbox2: '$10 First 30 Days',
            subscriptionbox3: 'Cancel Anytime',
          
            // Font size selections
            washnamefontsize: '32px', 
            box1fontsize: '20px',
            box2fontsize: '20px',
            box3fontsize: '20px',
          });
          setThemeData1({
            Theme1PrimaryColor: THEME1_PRIMARY_COLOR,
            Theme1SecondaryColor: THEME1_SECONDARY_COLOR,
            Theme1TextColor: THEME1_TEXT_COLOR
        });
    
        setThemeData2({
            Theme2PrimaryColor: THEME2_PRIMARY_COLOR,
            Theme2SecondaryColor: THEME2_SECONDARY_COLOR,
            Theme2TextColor: THEME2_TEXT_COLOR
        });
    
        setThemeData3({

            Theme3PrimaryColor: FREE_VACUUM_PRIMARY_COLOR,
            Theme3SecondaryColor: FREE_VACUUM_SECONDARY_COLOR,
            Theme3TextColor: FREE_VACUUM_TEXT_COLOR

        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    useEffect(() => {
        document.documentElement.style.setProperty('--Theme1PrimaryColor', themeData1.Theme1PrimaryColor);
        document.documentElement.style.setProperty('--Theme1SecondaryColor', themeData1.Theme1SecondaryColor);
        document.documentElement.style.setProperty('--Theme1TextColor', themeData1.Theme1TextColor);
    }, [themeData1]);
    useEffect(() => {
        document.documentElement.style.setProperty('--Theme2PrimaryColor', themeData2.Theme2PrimaryColor);
        document.documentElement.style.setProperty('--Theme2SecondaryColor', themeData2.Theme2SecondaryColor);
        document.documentElement.style.setProperty('--Theme2TextColor', themeData2.Theme2TextColor);
    }, [themeData2]);
    useEffect(() => {
        document.documentElement.style.setProperty('--Theme3PrimaryColor', themeData3.Theme3PrimaryColor);
        document.documentElement.style.setProperty('--Theme3SecondaryColor', themeData3.Theme3SecondaryColor);
        document.documentElement.style.setProperty('--Theme3TextColor', themeData3.Theme3TextColor);
    }, [themeData3]);

    return (
        <div className='wash-setup-container cwo-appsettings-wrap'>
            <Container>
            <div className="wash-customize-outer d-flex">
                <div className='setup-wrap preview-customizer'>
                    <div className="theme-picker d-flex justify-content-center">
                        <div className="theme-card">
                            <p>Theme 1</p>
                            <label className={`check-wrap d-flex w-100 position-relative  ${selectedTheme === 1 ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    className='input-check'
                                    onChange={() => handleThemeChange(1)}
                                    checked={selectedTheme === 1}
                                />
                                <span className="card-info d-flex w-100 align-items-center">
                                    <img src={CarTheme1} alt="Car Wash App" />
                                </span>
                            </label>
                        </div>
                        <div className="theme-card">
                            <p>Theme 2</p>
                            <label className={`check-wrap d-flex w-100 position-relative  ${selectedTheme === 2 ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    className='input-check'
                                    onChange={() => handleThemeChange(2)}
                                    checked={selectedTheme === 2}
                                />
                                <span className="card-info d-flex w-100 align-items-center">
                                    <img src={CarTheme2} alt="Car Wash App" />
                                </span>
                            </label>
                        </div>
                        <div className="theme-card">
                            <p>Theme 3</p>
                            <label className={`check-wrap d-flex w-100 position-relative  ${selectedTheme === 3 ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    className='input-check'
                                    onChange={() => handleThemeChange(3)}
                                    checked={selectedTheme === 3}
                                />
                                <span className="card-info d-flex w-100 align-items-center">
                                    <img src={CarTheme3} alt="Car Wash App" />
                                </span>
                            </label>
                        </div>
                    </div>
                    <div className="color-logo-customizer">
                        <div className="theme-element-wrap p-0 border-0">
                            <p>Custom Theme</p>
                            <div className="color-palette d-flex align-items-center justify-content-center">
                                <div className="color-box d-flex align-items-center justify-content-center position-relative" style={{ background: selectedTheme === 1 ? themeData1.Theme1PrimaryColor : selectedTheme === 2 ? themeData2.Theme2PrimaryColor : themeData3.Theme3PrimaryColor }}>
                                    <img src={PlusIcon} alt="Car Wash App" />
                                    <Form.Control
                                        type="color"
                                        id="CWColorInput1"
                                        key={`primary-${selectedTheme}`}
                                        name={selectedTheme === 1 ? "Theme1PrimaryColor" : selectedTheme === 2 ? "Theme2PrimaryColor" : "Theme3PrimaryColor"}
                                        className="color-input position-absolute"
                                        defaultValue={selectedTheme === 1 ? themeData1.Theme1PrimaryColor : selectedTheme === 2 ? themeData2.Theme2PrimaryColor : themeData3.Theme3PrimaryColor}
                                        title="Choose your color"
                                        onChange={ColorChangeHandler}
                                    />
                                </div>
                                <div className="color-box d-flex align-items-center justify-content-center position-relative" style={{ background: selectedTheme === 1 ? themeData1.Theme1SecondaryColor : selectedTheme === 2 ? themeData2.Theme2SecondaryColor : themeData3.Theme3SecondaryColor }}>
                                    <img src={PlusIcon} alt="Car Wash App" />
                                    <Form.Control
                                        type="color"
                                        id="CWColorInput2"
                                        key={`secondary-${selectedTheme}`}
                                        name={selectedTheme === 1 ? "Theme1SecondaryColor" : selectedTheme === 2 ? "Theme2SecondaryColor" : "Theme3SecondaryColor"}
                                        className="color-input position-absolute"
                                        defaultValue={selectedTheme === 1 ? themeData1.Theme1SecondaryColor : selectedTheme === 2 ? themeData2.Theme2SecondaryColor : themeData3.Theme3SecondaryColor}
                                        title="Choose your color"
                                        onChange={ColorChangeHandler}
                                    />
                                </div>
                                <div className="color-box d-flex align-items-center justify-content-center position-relative" style={{ background: selectedTheme === 1 ? themeData1.Theme1TextColor : selectedTheme === 2 ? themeData2.Theme2TextColor : themeData3.Theme3TextColor }}>
                                    <img src={PlusIcon} alt="Car Wash App" />
                                    <Form.Control
                                        type="color"
                                        id="CWColorInput3"
                                        key={`text-${selectedTheme}`}
                                        name={selectedTheme === 1 ? "Theme1TextColor" : selectedTheme === 2 ? "Theme2TextColor" : "Theme3TextColor"}
                                        className="color-input position-absolute"
                                        defaultValue={selectedTheme === 1 ? themeData1.Theme1TextColor : selectedTheme === 2 ? themeData2.Theme2TextColor : themeData3.Theme3TextColor}
                                        title="Choose your color"
                                        onChange={ColorChangeHandler}
                                    />
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="field-group d-flex">
                        <CWInput
                            id="washname"
                            name="washname"
                            type="text"
                            label="Car Wash Name"
                            value={formData.washname}
                            disabled
                        />
                        <CWSelect
                            id="washnamefontsize"
                            name="washnamefontsize"
                            options={fontSizeOptions}
                            label="Font Size"
                            dropdownGap={0}
                            dropdownPosition="auto"
                            placeholder=""
                            multi={false}
                            value={formData.washnamefontsize}
                            values={fontSizeOptions.filter(option => option.value === formData.washnamefontsize)}
                            onChange={(selectedOptions) => handleSelectChange(selectedOptions[0], 'washnamefontsize')}
                        />
                    </div>
                    <CWTextarea
                        id="titlecontent"
                        name="titlecontent"
                        type="text"
                        label="Title Content"
                        maxLength={TITLE_CONTENT_LIMIT}
                        isMandatory
                        value={formData.titlecontent}
                        rows={1}
                        onChange={handleInputChange}
                    />
                    {/* <CWInput
                        id="titlecontent"
                        name="titlecontent"
                        type="text"
                        label="Title Content"
                        value={formData.titlecontent}
                        onChange={handleInputChange}
                        maxLength={TITLE_CONTENT_LIMIT}
                    /> */}
                    <div className="field-group d-flex">
                        <CWInput
                            id="subscriptionbox1"
                            name="subscriptionbox1"
                            type="text"
                            label="Subscription Box 1"
                            value={formData.subscriptionbox1}
                            onChange={handleInputChange}
                            maxLength={SUBSCRIPTION_CONTENT_LIMIT}
                        />
                        <CWSelect
                            id="box1fontsize"
                            name="box1fontsize"
                            options={boxfontSizeOptions}
                            label="Font Size"
                            dropdownGap={0}
                            dropdownPosition="auto"
                            placeholder=""
                            multi={false}
                            value={formData.box1fontsize}
                            values={boxfontSizeOptions.filter(option => option.value === formData.box1fontsize)}
                            onChange={(selectedOptions) => handleSelectChange(selectedOptions[0], 'box1fontsize')}
                        />
                    </div>
                    <div className="field-group d-flex">
                        <CWInput
                            id="subscriptionbox2"
                            name="subscriptionbox2"
                            type="text"
                            label="Subscription Box 2"
                            value={formData.subscriptionbox2}
                            onChange={handleInputChange}
                            maxLength={SUBSCRIPTION_CONTENT_LIMIT}
                        />
                        <CWSelect
                            id="box2fontsize"
                            name="box2fontsize"
                            options={boxfontSizeOptions}
                            label="Font Size"
                            dropdownGap={0}
                            dropdownPosition="auto"
                            placeholder=""
                            multi={false}
                            value={formData.box2fontsize}
                            values={boxfontSizeOptions.filter(option => option.value === formData.box2fontsize)}
                            onChange={(selectedOptions) => handleSelectChange(selectedOptions[0], 'box2fontsize')}
                        />
                    </div>
                    <div className="field-group d-flex">
                        <CWInput
                            id="subscriptionbox3"
                            name="subscriptionbox3"
                            type="text"
                            label="Subscription Box 3"
                            value={formData.subscriptionbox3}
                            onChange={handleInputChange}
                            maxLength={SUBSCRIPTION_CONTENT_LIMIT}
                        />
                        <CWSelect
                            id="box3fontsize"
                            name="box3fontsize"
                            options={boxfontSizeOptions}
                            label="Font Size"
                            dropdownGap={0}
                            dropdownPosition="auto"
                            placeholder=""
                            multi={false}
                            value={formData.box3fontsize}
                            values={boxfontSizeOptions.filter(option => option.value === formData.box3fontsize)}
                            onChange={(selectedOptions) => handleSelectChange(selectedOptions[0], 'box3fontsize')}
                        />
                    </div>
                    <p className='note mb-2'>Note: Your changes will not be saved. Select a download option to use the modified version of the sign. To manually reset to the default design settings, use the Reset option below. </p>
                    <div className="btn-sec d-flex justify-content-end">
                        <Button title="Reset" variant="secondary" className="secondary-btn" onClick={showResetModal}>
                            Reset
                        </Button>
                    </div>
                </div>
                <div className="setup-wrap poster-preview">
                    <div className="cw-poster-template mx-auto">
                        {selectedTheme === 1 && <SmallSignTemplate01 companyLogoUrl={companyLogoUrl}bayId={bayId} appUrl={appUrl} washname={formData.washname} washnamefontsize={formData.washnamefontsize} titlecontent= {formData.titlecontent} 
                                                        subscriptionbox1={formData.subscriptionbox1} box1fontsize= {formData.box1fontsize} subscriptionbox2={formData.subscriptionbox2} box2fontsize= {formData.box2fontsize} 
                                                        subscriptionbox3={formData.subscriptionbox3} box3fontsize= {formData.box3fontsize} bayName = {bayName} />}
                        {selectedTheme === 2 && <SmallSignTemplate02 companyLogoUrl={companyLogoUrl}bayId={bayId} appUrl={appUrl} washname={formData.washname} washnamefontsize={formData.washnamefontsize} titlecontent= {formData.titlecontent} 
                                                        subscriptionbox1={formData.subscriptionbox1} box1fontsize= {formData.box1fontsize} subscriptionbox2={formData.subscriptionbox2} box2fontsize= {formData.box2fontsize} 
                                                        subscriptionbox3={formData.subscriptionbox3} box3fontsize= {formData.box3fontsize} bayName = {bayName}  bayType={BayTypeID}/>}
                        {selectedTheme === 3 && <FreeVacuumTemplate03 companyLogoUrl={companyLogoUrl}bayId={bayId} appUrl={appUrl} washname={formData.washname} washnamefontsize={formData.washnamefontsize} titlecontent= {formData.titlecontent} 
                                                        subscriptionbox1={formData.subscriptionbox1} box1fontsize= {formData.box1fontsize} subscriptionbox2={formData.subscriptionbox2} box2fontsize= {formData.box2fontsize} 
                                                        subscriptionbox3={formData.subscriptionbox3} box3fontsize= {formData.box3fontsize} bayName = {bayName}  bayType={BayTypeID}/>}
                    </div>
                </div>
            </div>
            </Container>
            {loading && <SmallLoader />}

            <Modal
                show={showResetpoup}
                onHide={hideResetModal}
                centered
                className='add-modal'
            >
                <Modal.Body className='text-center'>
                    <h5 className='f-bold text-center'>Are you sure, you want to reset the theme?</h5>
                    <div className="btn-sec d-grid">
                        <Button variant="light" className="secondary-btn" onClick={hideResetModal}>Not Now</Button>
                        <Button variant="primary" className='primary-btn btn-main m-0' onClick={resetCustomTheme}>Yes</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default SmallCarWashSignGeneration;
